module.exports = __webpack_public_path__ + "img/wardrobe.1b8b79bf.png";